import classNames from 'classnames';
import Typography from '@/components/atoms/typography/typography';
import Link from '@/components/utilities/link/link';
import styles from './duration-selector-item.module.scss';

export interface DurationSelectorItemProps {
  /** The class name to apply */
  className?: string;
  /** The label for the option */
  label: string;
  /** The state of the item */
  state?: 'active' | 'default' | 'disabled';
  /** Optional decoration text */
  tag?: string;
  /** The text for the item */
  text: string;
  /** The url to the new offers */
  url: string;
}

const DurationSelectorItem = ({
  className,
  label,
  url,
  state = 'default',
  tag,
  text,
}: DurationSelectorItemProps) => (
  <Link
    aria-label={label}
    className={classNames(styles.component, className, {
      [styles.isActive]: state === 'active',
      [styles.isDisabled]: state === 'disabled',
    })}
    url={url}
  >
    {tag && (
      <Typography className={styles.tag} tagStyle="labelSmall">
        {tag}
      </Typography>
    )}

    <Typography className={styles.label} tagStyle="bodyMediumBold">
      {label}
    </Typography>

    <Typography className={styles.text} tagStyle="bodyMedium">
      {text}
    </Typography>
  </Link>
);

DurationSelectorItem.displayName = 'DurationSelectorItem';

export default DurationSelectorItem;
